module.exports = __webpack_public_path__ + "static/media/preview.49cf3d53.png";